var _excluded = ["bg", "backgroundColor", "paddingHorizontal", "paddingVertical", "marginHorizontal", "marginVertical", "gap", "extend"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Box as BaseBox, applyMultiplier } from 'kilvin';
import { useFela } from 'react-fela';
var Box = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var bg = _ref.bg,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? bg : _ref$backgroundColor,
    paddingHorizontal = _ref.paddingHorizontal,
    paddingVertical = _ref.paddingVertical,
    marginHorizontal = _ref.marginHorizontal,
    marginVertical = _ref.marginVertical,
    gap = _ref.gap,
    extend = _ref.extend,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useFela = useFela(),
    theme = _useFela.theme;
  var spacing = applyMultiplier(theme.baselineGrid);
  return /*#__PURE__*/React.createElement(BaseBox, _extends({
    ref: ref
  }, props, {
    extend: [{
      backgroundColor: backgroundColor,
      paddingVertical: spacing(paddingVertical),
      paddingHorizontal: spacing(paddingHorizontal),
      marginVertical: spacing(marginVertical),
      marginHorizontal: spacing(marginHorizontal),
      gap: spacing(gap)
    }, extend]
  }));
});
export default Box;
Box.displayName = 'Box';
Box.propTypes = {
  /** The CSS background color */
  backgroundColor: PropTypes.string,
  /** A shorthand for backgroundColor */
  bg: PropTypes.oneOfType([PropTypes.array, PropTypes.string])
};